/**
 * Per-game level content. Each entry is an array (one element per level).
 * Levels are intentionally additive in difficulty / variety so a kid can
 * complete all 5+ levels of a single game in roughly an hour of play.
 */

// ============== Queen — Crown the Compliment (quiz) ==============
const Q_CROWN_COMPLIMENT = [
  // Level 1
  [
    {
      q: { en: "Which is a TRUE affirmation worth your crown?", es: "¿Cuál es una afirmación VERDADERA que merece tu corona?" },
      options: [
        { en: "I'm not as smart as her.", es: "No soy tan inteligente como ella.", correct: false },
        { en: "I'm learning, and I'm enough.", es: "Estoy aprendiendo y soy suficiente.", correct: true },
        { en: "Everyone thinks I'm weird.", es: "Todos piensan que soy raro/a.", correct: false },
      ],
    },
    {
      q: { en: "When you mess up, which voice is the QUEEN voice?", es: "Cuando te equivocas, ¿cuál es la voz de la REINA?" },
      options: [
        { en: "I'll always fail.", es: "Siempre fallaré.", correct: false },
        { en: "One slip doesn't define me.", es: "Un error no me define.", correct: true },
        { en: "Maybe I shouldn't even try.", es: "Tal vez no debería intentarlo.", correct: false },
      ],
    },
    {
      q: { en: "Pick the bravest self-talk:", es: "Elige la auto-charla más valiente:" },
      options: [
        { en: "I'm too much.", es: "Soy demasiado.", correct: false },
        { en: "I'm exactly the right amount of me.", es: "Soy exactamente la cantidad correcta de mí.", correct: true },
        { en: "I should be quieter.", es: "Debería ser más callada.", correct: false },
      ],
    },
  ],
  // Level 2 — body & appearance
  [
    {
      q: { en: "Looking in the mirror, the Queen says:", es: "Frente al espejo, la Reina dice:" },
      options: [
        { en: "Ugh, why do I look like that.", es: "Uf, ¿por qué me veo así?", correct: false },
        { en: "My body is mine. I respect it.", es: "Mi cuerpo es mío. Lo respeto.", correct: true },
      ],
    },
    {
      q: { en: "A friend gives you a compliment. You:", es: "Una amiga te hace un cumplido. Tú:" },
      options: [
        { en: "Brush it off — 'oh stop.'", es: "Lo niegas — 'ay, ya.'", correct: false },
        { en: "Smile and say thank you.", es: "Sonríes y das las gracias.", correct: true },
      ],
    },
    {
      q: { en: "Pick the kindest body talk:", es: "Elige la charla más amable hacia tu cuerpo:" },
      options: [
        { en: "I hate everything about me.", es: "Odio todo de mí.", correct: false },
        { en: "I am still building who I am.", es: "Aún estoy construyendo quién soy.", correct: true },
      ],
    },
    {
      q: { en: "The Queen's response to acne:", es: "La respuesta de la Reina al acné:" },
      options: [
        { en: "I'm gross. Hide.", es: "Soy asquerosa. Esconderme.", correct: false },
        { en: "My skin is just my skin.", es: "Mi piel es solo mi piel.", correct: true },
      ],
    },
  ],
  // Level 3 — social comparison
  [
    {
      q: { en: "Scrolling Instagram makes you feel small. The Queen:", es: "Instagram te hace sentir pequeña. La Reina:" },
      options: [
        { en: "Closes the app and breathes.", es: "Cierra la app y respira.", correct: true },
        { en: "Keeps scrolling 'just one more'.", es: "Sigue 'uno más'.", correct: false },
      ],
    },
    {
      q: { en: "A classmate gets the role you wanted:", es: "Una compañera consigue el papel que querías:" },
      options: [
        { en: "Hate her quietly.", es: "Odiarla en silencio.", correct: false },
        { en: "Be sad, then cheer her — and try again.", es: "Te entristeces, la felicitas y vuelves a intentar.", correct: true },
      ],
    },
    {
      q: { en: "What's a Queen-true thought about being 'last picked'?", es: "¿Un pensamiento de Reina sobre ser elegida 'al final'?" },
      options: [
        { en: "I'm worthless.", es: "Soy nada.", correct: false },
        { en: "One moment isn't my whole story.", es: "Un momento no es toda mi historia.", correct: true },
      ],
    },
    {
      q: { en: "Best Queen reaction to 'they all hate me':", es: "Mejor reacción ante 'todos me odian':" },
      options: [
        { en: "Spiral and isolate.", es: "Hundirme y aislarme.", correct: false },
        { en: "Reach out to one safe person.", es: "Contactar a una persona segura.", correct: true },
      ],
    },
  ],
  // Level 4 — boundaries
  [
    {
      q: { en: "A friend keeps borrowing money. Queen-move:", es: "Una amiga sigue pidiéndote dinero. Movida de Reina:" },
      options: [
        { en: "'I can't lend anymore — let's hang differently.'", es: "'No puedo prestar más — hagamos otra cosa.'", correct: true },
        { en: "Say yes and resent it.", es: "Decir sí y resentirlo.", correct: false },
      ],
    },
    {
      q: { en: "Saying no is:", es: "Decir no es:" },
      options: [
        { en: "Selfish.", es: "Egoísta.", correct: false },
        { en: "A full sentence.", es: "Una frase completa.", correct: true },
      ],
    },
    {
      q: { en: "Someone touches you in a way you don't like:", es: "Alguien te toca de una manera que no te gusta:" },
      options: [
        { en: "Smile and freeze.", es: "Sonreír y quedarte quieta.", correct: false },
        { en: "Say 'stop' and tell a safe adult.", es: "Decir 'basta' y avisar a un adulto seguro.", correct: true },
      ],
    },
    {
      q: { en: "Crown move when group-chat gossip starts:", es: "Movida de corona cuando empieza el chisme:" },
      options: [
        { en: "Pile on so they like you.", es: "Sumarte para gustarles.", correct: false },
        { en: "Step out or change the topic.", es: "Salir o cambiar de tema.", correct: true },
      ],
    },
    {
      q: { en: "A 'compliment' that actually feels gross:", es: "Un 'cumplido' que se siente feo:" },
      options: [
        { en: "Just take it — don't make it weird.", es: "Solo acéptalo — no lo hagas raro.", correct: false },
        { en: "'That made me uncomfortable.'", es: "'Eso me incomodó.'", correct: true },
      ],
    },
  ],
  // Level 5 — hardest scenarios
  [
    {
      q: { en: "After a breakup, the Queen reminds herself:", es: "Tras una ruptura, la Reina se recuerda:" },
      options: [
        { en: "I'm unlovable.", es: "No merezco amor.", correct: false },
        { en: "Their choice doesn't measure my worth.", es: "Su decisión no mide mi valor.", correct: true },
      ],
    },
    {
      q: { en: "Failed a big test. Queen response:", es: "Reprobaste un examen importante. Respuesta de Reina:" },
      options: [
        { en: "I'm done. I quit.", es: "Acabé. Me rindo.", correct: false },
        { en: "Cry. Then learn one thing. Then re-plan.", es: "Llora. Aprende algo. Re-planea.", correct: true },
      ],
    },
    {
      q: { en: "Someone calls you a slur online:", es: "Alguien te insulta en línea:" },
      options: [
        { en: "Internalize it.", es: "Internalizarlo.", correct: false },
        { en: "Block / report and tell a safe person.", es: "Bloquear / reportar y avisar a alguien seguro.", correct: true },
      ],
    },
    {
      q: { en: "You feel invisible at home:", es: "Te sientes invisible en casa:" },
      options: [
        { en: "Disappear into your room forever.", es: "Esconderte siempre en tu cuarto.", correct: false },
        { en: "Tell one trusted adult clearly: 'I need to be seen.'", es: "Dile claro a un adulto: 'Necesito que me veas.'", correct: true },
      ],
    },
    {
      q: { en: "Comparing to a 'perfect' sibling:", es: "Compararte con un hermano/a 'perfecto/a':" },
      options: [
        { en: "Their lane isn't your lane — keep walking yours.", es: "Su camino no es el tuyo — sigue el tuyo.", correct: true },
        { en: "Try to copy them exactly.", es: "Intentar copiarlos exacto.", correct: false },
      ],
    },
  ],
];

// ============== Queen — Mirror Match (match) ==============
const Q_MIRROR_MATCH = [
  // Level 1 — basic reframes
  [
    { a: { en: "I'm a failure.", es: "Soy un fracaso." }, b: { en: "I'm still learning.", es: "Sigo aprendiendo." } },
    { a: { en: "Nobody likes me.", es: "Nadie me quiere." }, b: { en: "I'm worthy of love.", es: "Soy digna de amor." } },
    { a: { en: "I can't do this.", es: "No puedo." }, b: { en: "I can try one small step.", es: "Puedo dar un pasito." } },
    { a: { en: "I'm not enough.", es: "No soy suficiente." }, b: { en: "I am enough.", es: "Soy suficiente." } },
  ],
  // Level 2 — body & energy
  [
    { a: { en: "I look gross.", es: "Me veo fea." }, b: { en: "My body carried me today.", es: "Mi cuerpo me cargó hoy." } },
    { a: { en: "I'm tired and useless.", es: "Estoy cansada e inútil." }, b: { en: "Rest is part of strength.", es: "Descansar es parte de la fuerza." } },
    { a: { en: "I'm too sensitive.", es: "Soy muy sensible." }, b: { en: "I feel deeply and that's a gift.", es: "Siento profundo y eso es un regalo." } },
    { a: { en: "I always cry.", es: "Siempre lloro." }, b: { en: "Tears are honesty.", es: "Las lágrimas son honestidad." } },
  ],
  // Level 3 — boundaries
  [
    { a: { en: "I can't say no.", es: "No puedo decir no." }, b: { en: "No is a full sentence.", es: "No es una frase completa." } },
    { a: { en: "Everyone needs me.", es: "Todos me necesitan." }, b: { en: "I need me first.", es: "Yo me necesito primero." } },
    { a: { en: "If I say no they'll leave.", es: "Si digo no se irán." }, b: { en: "The right people stay.", es: "Las personas correctas se quedan." } },
    { a: { en: "I'm too much.", es: "Soy demasiado." }, b: { en: "I'm the right amount of me.", es: "Soy la cantidad correcta de mí." } },
  ],
  // Level 4 — comparison
  [
    { a: { en: "She's prettier.", es: "Ella es más bonita." }, b: { en: "Beauty isn't a competition.", es: "La belleza no es una competencia." } },
    { a: { en: "I'm always last picked.", es: "Siempre me eligen al final." }, b: { en: "I pick myself.", es: "Yo me elijo." } },
    { a: { en: "Their life looks perfect.", es: "Su vida parece perfecta." }, b: { en: "Highlight reels aren't real life.", es: "Los carretes no son la vida real." } },
    { a: { en: "I'm behind everyone.", es: "Voy atrás de todos." }, b: { en: "I'm on my own timeline.", es: "Voy en mi propio tiempo." } },
  ],
  // Level 5 — identity
  [
    { a: { en: "I don't know who I am.", es: "No sé quién soy." }, b: { en: "I'm becoming.", es: "Me estoy convirtiendo." } },
    { a: { en: "I shouldn't be this way.", es: "No debería ser así." }, b: { en: "I'm allowed to be me.", es: "Tengo permiso de ser yo." } },
    { a: { en: "I'm broken.", es: "Estoy rota." }, b: { en: "I'm healing.", es: "Estoy sanando." } },
    { a: { en: "I'll never be enough.", es: "Nunca seré suficiente." }, b: { en: "I already am.", es: "Ya lo soy." } },
  ],
];

// ============== Queen — Affirmation Streak (tap) ==============
const _Q_TAP_BASE = [
  { en: "I am brave.", es: "Soy valiente.", good: true },
  { en: "You're useless.", es: "Eres inútil.", good: false },
  { en: "I am kind.", es: "Soy amable.", good: true },
  { en: "You're a loser.", es: "Eres una perdedora.", good: false },
  { en: "I am loved.", es: "Soy amada.", good: true },
  { en: "Nobody likes you.", es: "Nadie te quiere.", good: false },
  { en: "I matter.", es: "Importo.", good: true },
  { en: "You always mess up.", es: "Siempre lo arruinas.", good: false },
  { en: "I am enough.", es: "Soy suficiente.", good: true },
  { en: "Just give up.", es: "Solo ríndete.", good: false },
];
const Q_AFFIRM_STREAK = [
  _Q_TAP_BASE,
  [
    ..._Q_TAP_BASE,
    { en: "My voice counts.", es: "Mi voz cuenta.", good: true },
    { en: "You're a burden.", es: "Eres una carga.", good: false },
    { en: "I am healing.", es: "Estoy sanando.", good: true },
    { en: "You ruin everything.", es: "Lo arruinas todo.", good: false },
  ],
  [
    ..._Q_TAP_BASE,
    { en: "I am worthy.", es: "Soy digna.", good: true },
    { en: "You're too sensitive.", es: "Eres muy sensible.", good: false },
    { en: "My feelings are valid.", es: "Mis sentimientos son válidos.", good: true },
    { en: "Stop crying.", es: "Deja de llorar.", good: false },
    { en: "I am growing.", es: "Estoy creciendo.", good: true },
    { en: "You're weak.", es: "Eres débil.", good: false },
  ],
  [
    ..._Q_TAP_BASE,
    { en: "I am safe.", es: "Estoy a salvo.", good: true },
    { en: "You should be quieter.", es: "Debes callarte.", good: false },
    { en: "My story is mine.", es: "Mi historia es mía.", good: true },
    { en: "You're embarrassing.", es: "Das vergüenza.", good: false },
    { en: "I am chosen by me.", es: "Yo me elijo.", good: true },
    { en: "Everyone judges you.", es: "Todos te juzgan.", good: false },
    { en: "I am whole.", es: "Estoy completa.", good: true },
    { en: "You're broken.", es: "Estás rota.", good: false },
  ],
  [
    ..._Q_TAP_BASE,
    { en: "I am the queen of my mind.", es: "Soy la reina de mi mente.", good: true },
    { en: "You'll never be enough.", es: "Nunca serás suficiente.", good: false },
    { en: "I write my future.", es: "Yo escribo mi futuro.", good: true },
    { en: "You're nothing without them.", es: "No eres nada sin ellos.", good: false },
    { en: "I love who I'm becoming.", es: "Amo en quien me convierto.", good: true },
    { en: "Hide who you are.", es: "Esconde quién eres.", good: false },
    { en: "I deserve good things.", es: "Merezco cosas buenas.", good: true },
    { en: "You don't deserve happiness.", es: "No mereces ser feliz.", good: false },
    { en: "I am my own home.", es: "Soy mi propio hogar.", good: true },
    { en: "You're a disappointment.", es: "Eres una decepción.", good: false },
  ],
];

// ============== Queen — Power-Word Quiz ==============
const Q_POWER_QUIZ = [
  [
    {
      q: { en: "Big test today. Power-word is…", es: "Examen grande hoy. Tu palabra es…" },
      options: [
        { en: "Capable.", es: "Capaz.", correct: true },
        { en: "Doomed.", es: "Perdida.", correct: false },
      ],
    },
    {
      q: { en: "Argument with a friend. Power-word:", es: "Discutiste. Palabra:" },
      options: [
        { en: "Patient.", es: "Paciente.", correct: true },
        { en: "Petty.", es: "Mezquina.", correct: false },
      ],
    },
    {
      q: { en: "Trying something new:", es: "Algo nuevo:" },
      options: [
        { en: "Curious.", es: "Curiosa.", correct: true },
        { en: "Scared.", es: "Asustada.", correct: false },
      ],
    },
    {
      q: { en: "When you feel low:", es: "Cuando te sientes mal:" },
      options: [
        { en: "Worthy.", es: "Digna.", correct: true },
        { en: "Less-than.", es: "Inferior.", correct: false },
      ],
    },
  ],
  [
    {
      q: { en: "Speaking to a class:", es: "Hablar frente a la clase:" },
      options: [{ en: "Steady.", es: "Firme.", correct: true }, { en: "Small.", es: "Pequeña.", correct: false }],
    },
    {
      q: { en: "Forgive yourself:", es: "Perdónate:" },
      options: [{ en: "Soft.", es: "Suave.", correct: true }, { en: "Harsh.", es: "Dura.", correct: false }],
    },
    {
      q: { en: "Big dream:", es: "Sueño grande:" },
      options: [{ en: "Bold.", es: "Atrevida.", correct: true }, { en: "Selfish.", es: "Egoísta.", correct: false }],
    },
    {
      q: { en: "Feeling rejected:", es: "Te sientes rechazada:" },
      options: [{ en: "Whole.", es: "Completa.", correct: true }, { en: "Empty.", es: "Vacía.", correct: false }],
    },
  ],
  [
    {
      q: { en: "When fear knocks:", es: "Cuando llega el miedo:" },
      options: [{ en: "Brave.", es: "Valiente.", correct: true }, { en: "Frozen.", es: "Paralizada.", correct: false }],
    },
    {
      q: { en: "Trying again after failure:", es: "Volver a intentar:" },
      options: [{ en: "Resilient.", es: "Resiliente.", correct: true }, { en: "Useless.", es: "Inútil.", correct: false }],
    },
    {
      q: { en: "Saying no to peer pressure:", es: "Decir no a la presión:" },
      options: [{ en: "Rooted.", es: "Firme.", correct: true }, { en: "Weird.", es: "Rara.", correct: false }],
    },
    {
      q: { en: "After being misunderstood:", es: "Mal entendida:" },
      options: [{ en: "Clear.", es: "Clara.", correct: true }, { en: "Bitter.", es: "Amarga.", correct: false }],
    },
  ],
  [
    {
      q: { en: "Lonely night:", es: "Noche sola:" },
      options: [{ en: "Held.", es: "Acompañada.", correct: true }, { en: "Forgotten.", es: "Olvidada.", correct: false }],
    },
    {
      q: { en: "When jealousy rises:", es: "Sube la envidia:" },
      options: [{ en: "Inspired.", es: "Inspirada.", correct: true }, { en: "Bitter.", es: "Amarga.", correct: false }],
    },
    {
      q: { en: "Standing up for yourself:", es: "Defenderte:" },
      options: [{ en: "Sovereign.", es: "Soberana.", correct: true }, { en: "Rude.", es: "Grosera.", correct: false }],
    },
    {
      q: { en: "Setting a boundary:", es: "Poner un límite:" },
      options: [{ en: "Clear.", es: "Clara.", correct: true }, { en: "Mean.", es: "Mala.", correct: false }],
    },
  ],
  [
    {
      q: { en: "Showing up for yourself daily:", es: "Apareces por ti cada día:" },
      options: [{ en: "Devoted.", es: "Devota.", correct: true }, { en: "Selfish.", es: "Egoísta.", correct: false }],
    },
    {
      q: { en: "Asking for help:", es: "Pedir ayuda:" },
      options: [{ en: "Strong.", es: "Fuerte.", correct: true }, { en: "Weak.", es: "Débil.", correct: false }],
    },
    {
      q: { en: "Being misjudged:", es: "Te malinterpretan:" },
      options: [{ en: "Anchored.", es: "Anclada.", correct: true }, { en: "Lost.", es: "Perdida.", correct: false }],
    },
    {
      q: { en: "After a big win:", es: "Tras una gran victoria:" },
      options: [{ en: "Proud.", es: "Orgullosa.", correct: true }, { en: "Cocky.", es: "Engreída.", correct: false }],
    },
  ],
];

// ============== Victor — Speak-Up ==============
const V_SPEAK_UP = [
  [
    {
      q: { en: "A friend is bullied online. Best move?", es: "Molestan a un amigo en línea. ¿Mejor opción?" },
      options: [
        { en: "Stay silent.", es: "Quedarme callado.", correct: false },
        { en: "Check on them and report the post.", es: "Hablar con ellos y reportar.", correct: true },
        { en: "Pile on with the bullies.", es: "Sumarme.", correct: false },
      ],
    },
    {
      q: { en: "Overwhelmed at school. What do you say?", es: "Agobiado en la escuela. ¿Qué dices?" },
      options: [
        { en: "I'm fine.", es: "Estoy bien.", correct: false },
        { en: "I need a few minutes. Can we talk?", es: "Necesito unos minutos. ¿Hablamos?", correct: true },
      ],
    },
    {
      q: { en: "Sibling crosses a line. Healthy response?", es: "Tu hermano cruza un límite:" },
      options: [
        { en: "Yell and slam the door.", es: "Gritar y dar un portazo.", correct: false },
        { en: "Use 'I feel ___ when you ___'.", es: "Usar 'Me siento ___ cuando ___'.", correct: true },
      ],
    },
  ],
  [
    {
      q: { en: "Teacher said something that hurt:", es: "Un maestro dijo algo que dolió:" },
      options: [
        { en: "Ask to talk after class — calmly.", es: "Pedir hablar después — con calma.", correct: true },
        { en: "Storm out.", es: "Salir furioso.", correct: false },
      ],
    },
    {
      q: { en: "A friend pressures you to vape:", es: "Te presionan a vapear:" },
      options: [
        { en: "Try one — they'll get off your back.", es: "Probar — para que te dejen.", correct: false },
        { en: "'Not for me.' Walk away.", es: "'No es para mí.' Te vas.", correct: true },
      ],
    },
    {
      q: { en: "You see someone get cornered:", es: "Ves a alguien acorralado:" },
      options: [
        { en: "Walk past — not your fight.", es: "Pasar de largo.", correct: false },
        { en: "Grab an adult.", es: "Buscar a un adulto.", correct: true },
      ],
    },
    {
      q: { en: "A friend says 'I'm thinking about hurting myself.'", es: "Un amigo dice 'Pienso en hacerme daño.'" },
      options: [
        { en: "Tell a trusted adult and stay with them.", es: "Avisar a un adulto y quedarme con ellos.", correct: true },
        { en: "Promise to keep it secret.", es: "Prometer secreto.", correct: false },
        { en: "Ignore it.", es: "Ignorarlo.", correct: false },
      ],
    },
  ],
  [
    {
      q: { en: "Group chat starts a rumor:", es: "El grupo empieza un rumor:" },
      options: [
        { en: "Add a meme to it.", es: "Sumar un meme.", correct: false },
        { en: "'Hey — that's not it. Cut it.'", es: "'Oye — no es así. Basta.'", correct: true },
      ],
    },
    {
      q: { en: "A new kid sits alone at lunch:", es: "Un chico nuevo come solo:" },
      options: [
        { en: "Pretend you didn't see.", es: "Hacer como que no viste.", correct: false },
        { en: "Sit with them.", es: "Sentarte con él.", correct: true },
      ],
    },
    {
      q: { en: "You're mad at a parent:", es: "Estás enojado con un padre:" },
      options: [
        { en: "'Can we talk later when I'm calmer?'", es: "'¿Hablamos luego, más tranquilo?'", correct: true },
        { en: "Shut down for days.", es: "Cerrarte por días.", correct: false },
      ],
    },
    {
      q: { en: "A friend cancels last minute again:", es: "Un amigo cancela otra vez:" },
      options: [
        { en: "'This is the 3rd time. What's up?'", es: "'Es la 3ra vez. ¿Qué pasa?'", correct: true },
        { en: "Cut them silently.", es: "Cortarle sin decir nada.", correct: false },
      ],
    },
  ],
  [
    {
      q: { en: "You're scared to come out to a friend:", es: "Tienes miedo de salir del clóset con un amigo:" },
      options: [
        { en: "'I want to tell you something — and I trust you.'", es: "'Quiero contarte algo — y confío en ti.'", correct: true },
        { en: "Hide forever.", es: "Esconderlo siempre.", correct: false },
      ],
    },
    {
      q: { en: "A coach yells at you:", es: "Un coach te grita:" },
      options: [
        { en: "Talk to them later: 'That hit hard. Can we…?'", es: "Hablar luego: 'Eso me afectó. ¿Podemos…?'", correct: true },
        { en: "Quit on the spot.", es: "Renunciar ahí mismo.", correct: false },
      ],
    },
    {
      q: { en: "Online stranger DMs you:", es: "Un desconocido te escribe:" },
      options: [
        { en: "Block, screenshot, show a trusted adult.", es: "Bloquear, capturar, avisar.", correct: true },
        { en: "Reply to be polite.", es: "Responder por educación.", correct: false },
      ],
    },
    {
      q: { en: "You feel unsafe at home:", es: "No te sientes seguro en casa:" },
      options: [
        { en: "Tell ONE adult outside the home who you trust.", es: "Avisar a UN adulto de afuera de confianza.", correct: true },
        { en: "Keep it inside.", es: "Guardarlo dentro.", correct: false },
      ],
    },
  ],
  [
    {
      q: { en: "You disagree with a teacher's grade:", es: "No estás de acuerdo con la nota:" },
      options: [
        { en: "Ask 'Can we go over this together?'", es: "'¿Podemos revisarlo juntos?'", correct: true },
        { en: "Trash-talk online.", es: "Hablar mal en línea.", correct: false },
      ],
    },
    {
      q: { en: "A friend's parent makes a hurtful joke:", es: "El papá de un amigo bromea feo:" },
      options: [
        { en: "Laugh awkwardly.", es: "Reír forzado.", correct: false },
        { en: "Quietly tell your friend later it bothered you.", es: "Decirle a tu amigo luego que te molestó.", correct: true },
      ],
    },
    {
      q: { en: "You witness a racist incident:", es: "Presencias un acto racista:" },
      options: [
        { en: "Document it. Support the person. Report it.", es: "Documentar. Apoyar. Reportar.", correct: true },
        { en: "Stay out of it.", es: "Mantenerte fuera.", correct: false },
      ],
    },
    {
      q: { en: "You want help but feel weak asking:", es: "Quieres ayuda pero pedirla te incomoda:" },
      options: [
        { en: "'I need to talk. Got a sec?'", es: "'Necesito hablar. ¿Tienes un minuto?'", correct: true },
        { en: "Pretend you're fine.", es: "Fingir que estás bien.", correct: false },
      ],
    },
  ],
];

// ============== Victor — Help vs Harm (tap) ==============
const _V_TAP_BASE = [
  { en: "I hear you.", es: "Te escucho.", good: true },
  { en: "Get over it.", es: "Supéralo.", good: false },
  { en: "You're safe with me.", es: "Estás a salvo conmigo.", good: true },
  { en: "Stop being dramatic.", es: "Deja el drama.", good: false },
  { en: "Want to talk?", es: "¿Quieres hablar?", good: true },
  { en: "That's your fault.", es: "Es tu culpa.", good: false },
  { en: "I'm here.", es: "Estoy aquí.", good: true },
  { en: "Whatever.", es: "Lo que sea.", good: false },
];
const V_HELP_HARM = [
  _V_TAP_BASE,
  [..._V_TAP_BASE,
    { en: "How can I help?", es: "¿Cómo te ayudo?", good: true },
    { en: "You're too much.", es: "Eres demasiado.", good: false },
    { en: "Let's tell a trusted adult.", es: "Digamos a un adulto seguro.", good: true },
    { en: "Keep it secret.", es: "Mantenlo en secreto.", good: false },
  ],
  [..._V_TAP_BASE,
    { en: "Take your time.", es: "Tómate tu tiempo.", good: true },
    { en: "Hurry up.", es: "Apúrate.", good: false },
    { en: "Want me to sit with you?", es: "¿Me siento contigo?", good: true },
    { en: "Leave me alone.", es: "Déjame en paz.", good: false },
    { en: "You're not alone.", es: "No estás solo.", good: true },
    { en: "Figure it out yourself.", es: "Resuélvelo tú solo.", good: false },
  ],
  [..._V_TAP_BASE,
    { en: "Your feelings make sense.", es: "Tus sentimientos tienen sentido.", good: true },
    { en: "You're overreacting.", es: "Estás exagerando.", good: false },
    { en: "I believe you.", es: "Te creo.", good: true },
    { en: "That's not real.", es: "Eso no es real.", good: false },
    { en: "Let's breathe together.", es: "Respiremos juntos.", good: true },
    { en: "Snap out of it.", es: "Despierta ya.", good: false },
    { en: "I've got you.", es: "Te tengo.", good: true },
    { en: "Not my problem.", es: "No es mi problema.", good: false },
  ],
  [..._V_TAP_BASE,
    { en: "You matter to me.", es: "Importas para mí.", good: true },
    { en: "You're annoying.", es: "Eres molesto.", good: false },
    { en: "Tell me what hurts.", es: "Dime qué duele.", good: true },
    { en: "You always cry.", es: "Siempre lloras.", good: false },
    { en: "Let's get you help.", es: "Busquemos ayuda.", good: true },
    { en: "Toughen up.", es: "Hazte fuerte.", good: false },
    { en: "Want a hug?", es: "¿Un abrazo?", good: true },
    { en: "Stop bothering me.", es: "Deja de molestar.", good: false },
    { en: "I'm proud of you.", es: "Estoy orgulloso de ti.", good: true },
    { en: "You're a baby.", es: "Eres un bebé.", good: false },
  ],
];

// ============== Victor — Listen Match ==============
const V_LISTEN_MATCH = [
  [
    { a: { en: "I had the worst day.", es: "Tuve el peor día." }, b: { en: "Tell me what happened.", es: "Cuéntame qué pasó." } },
    { a: { en: "I feel invisible.", es: "Me siento invisible." }, b: { en: "I see you. I'm here.", es: "Te veo. Estoy aquí." } },
    { a: { en: "I messed up big time.", es: "La cagué en grande." }, b: { en: "We all do. Want help fixing it?", es: "A todos. ¿Te ayudo?" } },
    { a: { en: "I'm so scared.", es: "Tengo mucho miedo." }, b: { en: "That fear makes sense. You're not alone.", es: "Tiene sentido. No estás solo." } },
  ],
  [
    { a: { en: "I'm angry at my dad.", es: "Estoy enojado con mi papá." }, b: { en: "What did he do?", es: "¿Qué hizo?" } },
    { a: { en: "I don't fit in.", es: "No encajo." }, b: { en: "You fit just being you.", es: "Encajas siendo tú." } },
    { a: { en: "I'm exhausted.", es: "Estoy agotado." }, b: { en: "Want to just sit a sec?", es: "¿Nos sentamos un rato?" } },
    { a: { en: "I'm scared to fail.", es: "Tengo miedo a fallar." }, b: { en: "Failing isn't the end.", es: "Fallar no es el final." } },
  ],
  [
    { a: { en: "I'm anxious all the time.", es: "Vivo ansioso." }, b: { en: "Tell me what helps.", es: "Cuéntame qué te ayuda." } },
    { a: { en: "Nobody gets me.", es: "Nadie me entiende." }, b: { en: "Try me.", es: "Pruébame." } },
    { a: { en: "I want to disappear.", es: "Quiero desaparecer." }, b: { en: "Stay. Talk to me first.", es: "Quédate. Háblame primero." } },
    { a: { en: "I'm so lost.", es: "Estoy perdido." }, b: { en: "We'll figure it out — one step.", es: "Lo resolvemos — un paso." } },
  ],
  [
    { a: { en: "I cried at school.", es: "Lloré en la escuela." }, b: { en: "What set it off?", es: "¿Qué lo activó?" } },
    { a: { en: "Everyone is mad at me.", es: "Todos están enojados conmigo." }, b: { en: "Who's everyone, really?", es: "¿Todos quiénes?" } },
    { a: { en: "I lied to my mom.", es: "Le mentí a mi mamá." }, b: { en: "What feels right next?", es: "¿Qué se siente correcto ahora?" } },
    { a: { en: "I'm not enough.", es: "No soy suficiente." }, b: { en: "I think you are.", es: "Creo que sí lo eres." } },
  ],
  [
    { a: { en: "I'm bullied online.", es: "Me molestan en línea." }, b: { en: "Show me. We'll handle it together.", es: "Muéstrame. Lo manejamos juntos." } },
    { a: { en: "I feel unsafe.", es: "No me siento seguro." }, b: { en: "Let's call a safe adult right now.", es: "Llamemos a un adulto seguro ya." } },
    { a: { en: "I lost my best friend.", es: "Perdí a mi mejor amigo." }, b: { en: "That's real grief. I'm with you.", es: "Es un duelo real. Estoy contigo." } },
    { a: { en: "I don't know if I matter.", es: "No sé si importo." }, b: { en: "You matter to me.", es: "Me importas a mí." } },
  ],
];

// ============== Victor — Safe Person ==============
const V_SAFE_PERSON = [
  [
    { q: { en: "Someone you trust:", es: "Alguien en quien confías:" }, options: [{ en: "Listens without judging.", es: "Escucha sin juzgar.", correct: true }, { en: "Tells your secrets at school.", es: "Cuenta tus secretos.", correct: false }] },
    { q: { en: "A safe adult will:", es: "Un adulto seguro:" }, options: [{ en: "Take you seriously.", es: "Te toma en serio.", correct: true }, { en: "Laugh you off.", es: "Se ríe.", correct: false }] },
    { q: { en: "A safe friend:", es: "Un amigo seguro:" }, options: [{ en: "Sits with your hard feelings.", es: "Se sienta contigo en lo difícil.", correct: true }, { en: "Makes you feel guilty.", es: "Te hace sentir culpable.", correct: false }] },
    { q: { en: "Call/text 988 (US) because:", es: "Llama/escribe 988 (EE.UU.) porque:" }, options: [{ en: "Trained counselors listen.", es: "Consejeros entrenados escuchan.", correct: true }, { en: "They tell your school.", es: "Le dicen a tu escuela.", correct: false }] },
  ],
  [
    { q: { en: "A coach is safe if they:", es: "Un coach es seguro si:" }, options: [{ en: "Respect your no.", es: "Respeta tu no.", correct: true }, { en: "Push past your no.", es: "Pasan por encima de tu no.", correct: false }] },
    { q: { en: "An auntie/uncle who's safe:", es: "Una tía/tío seguro:" }, options: [{ en: "Keeps your trust.", es: "Mantiene tu confianza.", correct: true }, { en: "Gossips with your parents.", es: "Chismea con tus padres.", correct: false }] },
    { q: { en: "A teacher you can trust:", es: "Un maestro de confianza:" }, options: [{ en: "Believes you first.", es: "Te cree primero.", correct: true }, { en: "Dismisses you.", es: "Te ignora.", correct: false }] },
    { q: { en: "Online support is safe when:", es: "El apoyo en línea es seguro cuando:" }, options: [{ en: "From a verified hotline/site.", es: "De una línea/sitio verificado.", correct: true }, { en: "A stranger DMs you advice.", es: "Un desconocido te DM-a consejos.", correct: false }] },
  ],
  [
    { q: { en: "A safe space lets you:", es: "Un espacio seguro permite:" }, options: [{ en: "Cry without shame.", es: "Llorar sin vergüenza.", correct: true }, { en: "Get told to 'man up'.", es: "Que te digan 'sé un hombre'.", correct: false }] },
    { q: { en: "Trust signals from an adult:", es: "Señales de confianza:" }, options: [{ en: "Asks what you need.", es: "Pregunta qué necesitas.", correct: true }, { en: "Tells you what to feel.", es: "Te dice qué sentir.", correct: false }] },
    { q: { en: "Sibling support looks like:", es: "Apoyo entre hermanos:" }, options: [{ en: "Showing up when it matters.", es: "Aparecer cuando importa.", correct: true }, { en: "Mocking your feelings.", es: "Burlarse de lo que sientes.", correct: false }] },
    { q: { en: "Real friend, late at night:", es: "Amigo real, de madrugada:" }, options: [{ en: "Answers without judgment.", es: "Contesta sin juicio.", correct: true }, { en: "Calls you 'a lot' the next day.", es: "Te llama 'pesado/a' al día siguiente.", correct: false }] },
  ],
  [
    { q: { en: "Adult crosses a line. Tell:", es: "Adulto cruza línea. Decir a:" }, options: [{ en: "Another trusted adult right away.", es: "Otro adulto de confianza ya.", correct: true }, { en: "Nobody.", es: "Nadie.", correct: false }] },
    { q: { en: "Friend asks to keep abuse secret:", es: "Amigo pide secreto sobre abuso:" }, options: [{ en: "Tell a safe adult — secrets harm.", es: "Avisar a un adulto seguro — el secreto daña.", correct: true }, { en: "Keep it forever.", es: "Guardarlo para siempre.", correct: false }] },
    { q: { en: "When 911 is the right call:", es: "Cuándo 911 (EE.UU.):" }, options: [{ en: "Someone is in immediate danger.", es: "Alguien en peligro inmediato.", correct: true }, { en: "You're a little anxious.", es: "Estás un poco ansioso.", correct: false }] },
    { q: { en: "Hotlines are for:", es: "Las líneas son para:" }, options: [{ en: "Anyone — crisis or not.", es: "Cualquiera — crisis o no.", correct: true }, { en: "Only 'serious' problems.", es: "Solo problemas 'serios'.", correct: false }] },
  ],
  [
    { q: { en: "Your safest person tonight:", es: "Tu persona más segura esta noche:" }, options: [{ en: "Someone who's answered before.", es: "Alguien que ya respondió antes.", correct: true }, { en: "Someone who shamed you last.", es: "Alguien que te avergonzó la última vez.", correct: false }] },
    { q: { en: "Build a 3-person safety list:", es: "Arma una lista de 3 personas:" }, options: [{ en: "Mix of friends + adults.", es: "Mezcla amigos + adultos.", correct: true }, { en: "Only random people.", es: "Solo personas al azar.", correct: false }] },
    { q: { en: "Ask for help by saying:", es: "Pedir ayuda diciendo:" }, options: [{ en: "'I need to talk. It's serious.'", es: "'Necesito hablar. Es serio.'", correct: true }, { en: "'Never mind.'", es: "'Olvídalo.'", correct: false }] },
    { q: { en: "If they say no, you:", es: "Si dicen no, tú:" }, options: [{ en: "Try the next person on your list.", es: "Sigues con la siguiente persona.", correct: true }, { en: "Give up.", es: "Te rindes.", correct: false }] },
  ],
];

// ============== Cam — Breath Wave (breath) ==============
const C_BREATH_GAME = [
  { rounds: 6, inhale: 4, exhale: 6 },
  { rounds: 8, inhale: 4, exhale: 6 },
  { rounds: 8, inhale: 5, exhale: 7 },
  { rounds: 10, inhale: 4, exhale: 8 },
  { rounds: 12, inhale: 5, exhale: 8 },
];

// ============== Cam — Calm Sequence ==============
const C_CALM_SEQUENCE = [
  ["blue", "amber", "violet", "emerald"],
  ["blue", "amber", "violet", "emerald"],
  ["blue", "amber", "violet", "emerald", "cyan"],
  ["blue", "amber", "violet", "emerald", "cyan", "rose"],
  ["blue", "amber", "violet", "emerald", "cyan", "rose"],
];

// ============== Cam — Color Calm Tap ==============
const _C_TAP_BASE = [
  { en: "Ocean blue", es: "Azul océano", good: true, color: "#1d4ed8" },
  { en: "Lava red", es: "Rojo lava", good: false, color: "#dc2626" },
  { en: "Forest teal", es: "Verde bosque", good: true, color: "#0d9488" },
  { en: "Volcano orange", es: "Naranja volcán", good: false, color: "#ea580c" },
  { en: "Twilight violet", es: "Violeta crepúsculo", good: true, color: "#7c3aed" },
  { en: "Fire yellow", es: "Amarillo fuego", good: false, color: "#facc15" },
  { en: "Glacier mint", es: "Menta glaciar", good: true, color: "#22d3ee" },
  { en: "Coral red", es: "Coral", good: false, color: "#fb7185" },
];
const C_COLOR_TAP = [
  _C_TAP_BASE,
  [..._C_TAP_BASE,
    { en: "Midnight indigo", es: "Índigo medianoche", good: true, color: "#312e81" },
    { en: "Sunset rose", es: "Rosa atardecer", good: false, color: "#f43f5e" },
  ],
  [..._C_TAP_BASE,
    { en: "Sky teal", es: "Cielo verdoso", good: true, color: "#14b8a6" },
    { en: "Brick red", es: "Rojo ladrillo", good: false, color: "#b91c1c" },
    { en: "Sea foam", es: "Espuma de mar", good: true, color: "#6ee7b7" },
    { en: "Amber gold", es: "Oro ámbar", good: false, color: "#f59e0b" },
  ],
  [..._C_TAP_BASE,
    { en: "Storm grey-blue", es: "Gris tormenta", good: true, color: "#475569" },
    { en: "Sunset coral", es: "Coral atardecer", good: false, color: "#fb923c" },
    { en: "Glacier white-blue", es: "Blanco glaciar", good: true, color: "#bae6fd" },
    { en: "Spicy red", es: "Rojo picante", good: false, color: "#ef4444" },
    { en: "Lavender mist", es: "Niebla lavanda", good: true, color: "#c4b5fd" },
    { en: "Tangerine", es: "Mandarina", good: false, color: "#fb923c" },
  ],
  [..._C_TAP_BASE,
    { en: "Deep ocean", es: "Océano profundo", good: true, color: "#0c4a6e" },
    { en: "Hot magenta", es: "Magenta fuerte", good: false, color: "#db2777" },
    { en: "Pine green", es: "Verde pino", good: true, color: "#166534" },
    { en: "Sun gold", es: "Oro sol", good: false, color: "#eab308" },
    { en: "Aurora purple", es: "Aurora violeta", good: true, color: "#a78bfa" },
    { en: "Crimson", es: "Carmesí", good: false, color: "#9f1239" },
    { en: "Frost blue", es: "Azul escarcha", good: true, color: "#7dd3fc" },
    { en: "Burning orange", es: "Naranja ardiente", good: false, color: "#c2410c" },
  ],
];

// ============== Cam — Coping Toolbox Quiz ==============
const C_COPING_QUIZ = [
  [
    { q: { en: "Heart racing before a test:", es: "Corazón acelerado antes del examen:" }, options: [{ en: "Take 5 slow breaths.", es: "5 respiraciones lentas.", correct: true }, { en: "Hold your breath.", es: "Aguanta el aire.", correct: false }] },
    { q: { en: "Can't sleep:", es: "No puedes dormir:" }, options: [{ en: "Name 5 things you see.", es: "Nombra 5 cosas que ves.", correct: true }, { en: "Scroll until you crash.", es: "Desliza hasta caer.", correct: false }] },
    { q: { en: "Anger spike at home:", es: "Pico de enojo:" }, options: [{ en: "Step outside. Inhale 4 / exhale 6.", es: "Sal. Inhala 4 / exhala 6.", correct: true }, { en: "Slam the door.", es: "Dar un portazo.", correct: false }] },
    { q: { en: "Sadness wave:", es: "Ola de tristeza:" }, options: [{ en: "Hand on heart. Notice.", es: "Mano al corazón. Nota.", correct: true }, { en: "Call yourself stupid.", es: "Insultarte.", correct: false }] },
    { q: { en: "Anxiety in a crowd:", es: "Ansiedad entre mucha gente:" }, options: [{ en: "Press feet into floor — slow exhale.", es: "Pies firmes — exhala lento.", correct: true }, { en: "Run out without a word.", es: "Salir corriendo.", correct: false }] },
  ],
  [
    { q: { en: "Panic spike:", es: "Pico de pánico:" }, options: [{ en: "Cold water on wrists.", es: "Agua fría en muñecas.", correct: true }, { en: "Hold your breath in fear.", es: "Aguantar el aire.", correct: false }] },
    { q: { en: "Numb / shut-down:", es: "Bloqueado/numb:" }, options: [{ en: "Smell something strong — coffee/citrus.", es: "Huele algo fuerte — café/cítrico.", correct: true }, { en: "Scroll for an hour.", es: "Desliza una hora.", correct: false }] },
    { q: { en: "Stuck on a thought loop:", es: "Pensamiento en bucle:" }, options: [{ en: "Write it. Read it. Rip it.", es: "Escribirlo. Leerlo. Romperlo.", correct: true }, { en: "Re-think it harder.", es: "Pensarlo más fuerte.", correct: false }] },
    { q: { en: "Need to feel safe RIGHT now:", es: "Necesitas sentirte a salvo YA:" }, options: [{ en: "5-4-3-2-1 senses grounding.", es: "5-4-3-2-1 sentidos.", correct: true }, { en: "Run away.", es: "Huir.", correct: false }] },
  ],
  [
    { q: { en: "Pre-game nerves:", es: "Nervios pre-partido:" }, options: [{ en: "Box breathing 4-4-4-4.", es: "Respiración cuadrada 4-4-4-4.", correct: true }, { en: "Energy drinks.", es: "Bebidas energéticas.", correct: false }] },
    { q: { en: "Argument cooldown:", es: "Después de discutir:" }, options: [{ en: "10-min walk. No phone.", es: "Camina 10 min. Sin celular.", correct: true }, { en: "Re-read the texts.", es: "Releer los mensajes.", correct: false }] },
    { q: { en: "Spiraling at 2am:", es: "Espirales a las 2am:" }, options: [{ en: "Write 3 thoughts. Sleep. Re-read at 8am.", es: "Escribe 3 ideas. Duerme. Releer a las 8.", correct: true }, { en: "Text everyone.", es: "Escribir a todos.", correct: false }] },
    { q: { en: "Bored anxiety:", es: "Ansiedad por aburrimiento:" }, options: [{ en: "Two-minute stretch.", es: "Estiramiento de 2 minutos.", correct: true }, { en: "Doomscroll.", es: "Scroll perpetuo.", correct: false }] },
  ],
  [
    { q: { en: "Grief day:", es: "Día de duelo:" }, options: [{ en: "Let yourself feel + reach out to one person.", es: "Permítete sentir + escribe a una persona.", correct: true }, { en: "Numb it with TikTok.", es: "Adormecerlo con TikTok.", correct: false }] },
    { q: { en: "Post-fight regret:", es: "Arrepentimiento tras pelea:" }, options: [{ en: "Send a short repair text.", es: "Manda un mensaje breve de reparación.", correct: true }, { en: "Pretend it didn't happen.", es: "Fingir que no pasó.", correct: false }] },
    { q: { en: "Overstimulated:", es: "Sobre-estimulado/a:" }, options: [{ en: "Dim lights. Quiet 10 min.", es: "Bajar luces. 10 min de silencio.", correct: true }, { en: "Loud music + screens.", es: "Música alta + pantallas.", correct: false }] },
    { q: { en: "Body tense:", es: "Cuerpo tenso:" }, options: [{ en: "Slow body scan top-to-toe.", es: "Escaneo corporal lento.", correct: true }, { en: "Ignore until it hurts.", es: "Ignorarlo hasta que duela.", correct: false }] },
  ],
  [
    { q: { en: "Self-harm urge:", es: "Impulso de hacerte daño:" }, options: [{ en: "Call/text 988. Tell a safe adult.", es: "Llama/escribe 988. Avisa.", correct: true }, { en: "Ignore the urge alone.", es: "Ignorarlo solo/a.", correct: false }] },
    { q: { en: "Big homework freeze:", es: "Bloqueo con tarea:" }, options: [{ en: "Tiny first step — 2 minutes only.", es: "Paso mini — solo 2 minutos.", correct: true }, { en: "Wait until you 'feel ready'.", es: "Esperar a 'estar listo'.", correct: false }] },
    { q: { en: "Friend ghosted you:", es: "Un amigo te ignora:" }, options: [{ en: "Sit with sadness. Don't spiral.", es: "Acepta la tristeza. No espirales.", correct: true }, { en: "Send 30 'are we ok?' texts.", es: "Mandar 30 '¿estamos bien?'", correct: false }] },
    { q: { en: "Body shame attack:", es: "Vergüenza corporal:" }, options: [{ en: "Cover the mirror. Breathe. Walk.", es: "Tapa el espejo. Respira. Camina.", correct: true }, { en: "Stand in front of it longer.", es: "Quedarte ahí más tiempo.", correct: false }] },
  ],
];

export const GAME_CONTENT = {
  q_crown_compliment: Q_CROWN_COMPLIMENT,
  q_mirror_match: Q_MIRROR_MATCH,
  q_affirm_streak: Q_AFFIRM_STREAK,
  q_power_quiz: Q_POWER_QUIZ,

  v_speak_up: V_SPEAK_UP,
  v_help_harm: V_HELP_HARM,
  v_listen_match: V_LISTEN_MATCH,
  v_safe_person: V_SAFE_PERSON,

  c_breath_game: C_BREATH_GAME,
  c_calm_sequence: C_CALM_SEQUENCE,
  c_color_tap: C_COLOR_TAP,
  c_coping_quiz: C_COPING_QUIZ,
};
